export default __webpack_public_path__ + "static/media/Made-by-desgin.23ab56c4.png";